import swal from 'sweetalert2';
import request from 'common/request';
import { ACTION_TYPES } from '../../../constants';
import { putAssessmentLock } from './putAssessmentLock';

export function postLoginUser({ username, password }) {
  return (dispatch) => {
    dispatch(postLoginUserFailure(''));
    request
      .post('/login', {
        username,
        password,
      })
      .then(function (response) {
        const { redirect, candidateId, message } = response.data;
        if (message) {
          dispatch(postLoginUserFailure(message));
        } else if (redirect) {
          dispatch(putAssessmentLock(candidateId, true));
          swal({
            width: 800,
            confirmButtonText: 'I Agree',
            cancelButtonText: 'I Disagree',
            showCancelButton: true,
            title: '<strong>COMPETAS Assessment Terms and Conditions</strong>',
            html: `<p style="text-align: left">
                The assessment is to ascertain your strengths on the topics you have self-assessed, the following rules apply where no information source shall be available to you during your assessment, failure to comply with the following requirements may invalidate your assessment.
              </p>
              <br />
              <p style="text-align: left">
                <strong>Test Environment Requirements</strong>
                <br />
                <ol style="margin-top: 10px; margin-left: 50px; text-align: left">
                  <li>You must take the assessment in the same room that you scanned during the ProctorExam setup.</li>
                  <li>The assessment must be completed within one <b><u>3-hour</u></b> session. However, comfort breaks are permitted during the assessment, but the clock continues to run.</li>
                  <li>No other person is allowed to enter the room while you are taking the proctored assessment.</li>
                  <li>The lighting in the room must be bright enough to be considered “daylight” quality. Overhead lighting is preferred. If overhead lighting is not available, the source of light must not be behind you.</li>
                  <li>You must sit at a clean desk or table.</li>
                  <li>The desk or walls around you must not have any writing, mirrors or reflective surfaces.</li>
                  <li>The room must be as quiet as possible. Sounds such as music or television are not permitted.</li>
                  <li>The following items <b><u>must not be on your desk</u></b> or used during your proctored assessment:
                    <ul style="margin-left: 30px">
                      <li>•	Books</li>
                      <li>•	Paper</li>
                      <li>•	Pens</li>
                      <li>•	Calculators</li>
                      <li>•	Textbooks</li>
                      <li>•	Notebook</li>
                      <li>•	Any other electronic devices (smart watches, tablets, mobile phones etc.)</li>
                    </ul>
                  </li>
                </ol>
              </p>
              <br />
              <p style="text-align: left">
                <strong>Computer and Browser Requirements</strong>
                <br />
                <ol style="margin-top: 10px; margin-left: 50px; text-align: left">
                  <li>You are responsible for making sure that the ProctorExam software works with your computer/mobile phone before you continue to your proctored assessment.</li>
                  <li>You must close all other programs or windows on your testing computer before you begin the assessment </li>
                  <li><b><u>You must not use the following tools or have open during your assessment:</u></b>
                    <ul style="margin-left: 30px">
                      <li>•	Programs such as Excel, Word, or PowerPoint</li>
                      <li>•	Communication programs such as Skype, instant messenger etc.</li>
                      <li>•	Any webpage other than ProctorExam live monitoring and the COMPETAS assessment.</li>
                    </ul>
                  </li>
                </ol>
              </p>
              <br />
              <p style="text-align: left">
                <strong>Your Behaviour</strong>
                <br />
                <ol style="margin-top: 10px; margin-left: 50px; text-align: left">
                  <li>You must dress as though you are in a public setting.</li>
                  <li><b><u>You must not use headphones, ear buds, or any other type of listening equipment.</u></b></li>
                  <li>You must not communicate with any other person by any means.</li>
                  <li>Any noise and talking will be analysed for suspicious behaviour, please ensure you are in a quiet environment and that you refrain from talking out loud.</li>
                  <li>No mobile phones other than the one being used to record your proctor session.</li>
                </ol>
              </p>
              <br />
              <p style="text-align: left">
                <strong>Additional Time or Special Allowances</strong>
                <br />
                If you have special requirements that require additional time or specific accommodations to take the assessment, please consult your Sponsor before you make any choices on the assessment page.
              </p>
              <br />
              <p style="text-align: left">
                <strong>Consequences of Rule Violations</strong>
                <br />
                If you are found to be violating any of these rules, COMPETAS reserve the right to void assessment results and notify your Sponsor accordingly with any applicable evidence.
                <br />
                If you have questions during your assessment, please use the chat facility function built into the ProctorExam live monitoring webpage.
                <br />
                By proceeding to begin your assessment, you are agreeing to the above assessment rules and requirements.
              </p>
          `,
          }).then(({ value }) => {
            if (value) {
              dispatch(putAssessmentLock(candidateId, false));

              // Relogin candidate when terms have bene agreed
              request
                .post('/login', {
                  username,
                  password,
                })
                .then(function (response) {
                  const { redirect, message } = response.data;

                  if (message) {
                    dispatch(postLoginUserFailure(message));
                  } else if (redirect) {
                    window.location = redirect;
                  }
                })
                .catch(function (error) {
                  console.error(error);
                });
            }
          });
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  };
}

function postLoginUserFailure(message) {
  return {
    type: ACTION_TYPES.LOGIN.FAILURE,
    payload: {
      message: message,
    },
  };
}



// WEBPACK FOOTER //
// ./src/pages/login/components/loginForm/actions/postLoginUser.js